import React from 'react';
import Moment from 'moment';
import ReactPlayer from 'react-player';
import ReactMarkdown from 'react-markdown';
import VideoThumbnail from './VideoThumbnail';

function getDetailsText(item) {
  return item?.description || item?.file?.description || '';
}

function shouldShowDetails(item) {
  // Keep explicit "false" behavior, but default to showing details otherwise.
  return item?.showDetails !== false;
}

function FeatureItem(featureItem) {
  let item = featureItem.featureItem[0];

  if (featureItem.featureItem.length === 0) {
    return null;
  }

  return (
    <div>
      <h3 className="section-title row news-layout">Featured</h3>
      <div className="section-content row cubs-news">
        <div id={item.name} className="col md-6 flex-item gallery-item">
          {ReactPlayer.canPlay(item?.file?.url || '') ? (
            shouldShowDetails(item) ? (
              <>
                <div className="news-img-container">
                  <div className="player-wrapper">
                    <ReactPlayer
                      config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                      id={item.name}
                      className="react-player"
                      onStart={() =>
                        window.dataLayer &&
                        window.dataLayer.push({ event: 'gallery_video_start', video_name: item.name })
                      }
                      onEnded={() =>
                        window.dataLayer &&
                        window.dataLayer.push({ event: 'gallery_video_end', video_name: item.name })
                      }
                      controls={true}
                      light={
                        (item?.file?.url || '').includes('videos') ? (
                          <VideoThumbnail
                            videoUrl={item.file.url}
                            thumbnailHandler={(thumbnail) => thumbnail}
                            snapshotAtTime={item.snapshotTime}
                          />
                        ) : true
                      }
                      muted={true}
                      width="100%"
                      height="100%"
                      url={item.file.url}
                    />
                  </div>
                </div>
                <h3>
                  <b>{item.name}</b>
                </h3>
                <p>{Moment.utc(item.releaseDate).format('MM/DD/YYYY')}</p>
                <ReactMarkdown className="black news-markdown" children={getDetailsText(item)} />
              </>
            ) : (
              <div className="news-img-container">
                <div className="player-wrapper">
                  <ReactPlayer
                    config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                    id={item.name}
                    className="react-player"
                    onStart={() =>
                      window.dataLayer &&
                      window.dataLayer.push({ event: 'gallery_video_start', video_name: item.name })
                    }
                    onEnded={() =>
                      window.dataLayer &&
                      window.dataLayer.push({ event: 'gallery_video_end', video_name: item.name })
                    }
                    controls={true}
                    light={
                      (item?.file?.url || '').includes('videos') ? (
                        <VideoThumbnail
                          videoUrl={item.file.url}
                          thumbnailHandler={(thumbnail) => thumbnail}
                          snapshotAtTime={item.snapshotTime}
                        />
                      ) : true
                    }
                    muted={true}
                    width="100%"
                    height="100%"
                    url={item.file.url}
                  />
                </div>
              </div>
            )
          ) : shouldShowDetails(item) ? (
            <>
              <div className="news-img-container">
                <div className="player-wrapper">
                  <img src={item.file.url} alt="news" />
                </div>
              </div>
              <h3>
                <b>{item.name}</b>
              </h3>
              <p>{Moment.utc(item.releaseDate).format('MM/DD/YYYY')}</p>
              <ReactMarkdown className="black news-markdown" children={getDetailsText(item)} />
            </>
          ) : (
            <div className="news-img-container">
              <div className="player-wrapper">
                <img src={item.file.url} alt="news" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default FeatureItem;
